<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Gerar CTE em Lote</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreateCteLote()" v-b-tooltip.hover.left="'Gerar CTE em Lote'"><i class="ft-plus"></i></a></li>
                                    <li><a @click="onImportXml()" v-b-tooltip title="Importar XML NFe" v-if="getPermission('xmlnfe.import')"><i class="fa fa-code"></i></a></li>
                                    <li><a @click="onImportXmlCte()" v-b-tooltip title="Importar XML CTe" v-if="getPermission('xmlcte.import')"><i class="fa fa-codepen"></i></a></li>
                                    <li><a @click="onShowHelp()" v-b-tooltip title="Ajuda"><i class="ft-help-circle"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                        api-url="/api/gerarctelote"
                                        :fields="fields"
                                        :css="css"
                                        :append-params="moreParams"
                                        track-by="pedunicar_id"
                                        pagination-path=""
                                        detail-row-component="gerarctelote-detalhes"
                                        @vuetable:load-error="onError"
                                        @vuetable:pagination-data="onPaginationData"
                                        @vuetable:loaded="onLoaded"
                                      >
                                      <template slot="selecionado" slot-scope="props">
                                          <b-form-checkbox buttons
                                                           button-variant="secondary"
                                                           v-model="props.rowData.selecionado"
                                                           value="1"
                                                           unchecked-value="2">
                                          </b-form-checkbox>
                                      </template>

                                      <template slot="pessoa" slot-scope="props">
                                          {{ props.rowData.pedido.pessoa_tomador.pessoa_juridica.razao_social }}
                                      </template>

                                      <template slot="num_container" slot-scope="props">
                                          <span v-if="props.rowData.carga_doc_unidade_carga.length>=1">
                                              <b-form-input type="text"
                                                      placeholder="Container"
                                                      v-model="props.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.num_container"
                                                      >
                                               </b-form-input>
                                           </span>

                                           <span v-if="props.rowData.carga_doc_unidade_carga.length==0">
                                               <b-form-input type="text"
                                                       placeholder="Container"
                                                       v-model="props.rowData.num_container"
                                                       >
                                                </b-form-input>
                                           </span>
                                      </template>

                                      <template slot="num_lacre" slot-scope="props">
                                          <span v-if="props.rowData.carga_doc_unidade_carga.length>=1">
                                              <b-form-input type="text"
                                                          placeholder="Lacre"
                                                          v-model="props.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.num_lacre"
                                                          >
                                              </b-form-input>
                                          </span>

                                          <span v-if="props.rowData.carga_doc_unidade_carga.length==0">
                                              <b-form-input type="text"
                                                          placeholder="Lacre"
                                                          v-model="props.rowData.num_lacre"
                                                          >
                                              </b-form-input>
                                          </span>
                                      </template>

                                      <template slot="obs" slot-scope="props">

                                          <span v-if="props.rowData.carga_doc_unidade_carga.length>=1">
                                              <b-form-input type="text"
                                                          placeholder="Observação"
                                                          v-model="props.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.obs"
                                                          >
                                              </b-form-input>
                                          </span>

                                          <span v-if="props.rowData.carga_doc_unidade_carga.length==0">
                                              <b-form-input type="text"
                                                          placeholder="Observação"
                                                          v-model="props.rowData.pedido.obs_cte"
                                                          >
                                              </b-form-input>
                                          </span>
                                      </template>

                                      <template slot="status_uc" slot-scope="props">
                                          <span class="badge badge-warning" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-warning" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}[ {{ props.rowData.carga_doc_unidade_carga.length }} ] </span>
                                          <span class="badge badge-danger" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>
                                      </template>

                                      <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">

                                            <a @click="onAssociarDoc(props, props.rowIndex)" v-b-tooltip title="Associar/Desassociar Documentos" v-if="getPermission('pedido.update')"><i class="fa fa-list"></i></a>
                                            <a @click="onDesassociar(props.rowData)" v-b-tooltip title="Desassociar Todos Docs" v-if="getPermission('pedido.update')&&(props.rowData.carga_doc_unidade_carga.length>0)"><i class="fa fa-indent"></i></a>
                                            <span v-if="props.rowData.status.valor==3">
                                                <a @click="onGerarCteLote(props.rowData.pedunicar_id, props.rowData)" v-b-tooltip title="Gerar CTE"  v-if="getPermission('pedido.update')"><i class="fa fa-gear"></i></a>
                                                <a @click="onGerarCteAjustado(props, props.rowIndex)" v-b-tooltip title="Gerar CTE Ajustado"  v-if="getPermission('pedido.update')"><i class="fa fa-table"></i></a>
                                            </span>
                                            <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                          </button>
                                        </div>
                                      </template>
                                  </vuetable>
                              </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
              </div>
          </div>
          <!-- Modal Component -->
          <b-modal id="modal_upload_xml"
                   ref="modal_upload_xml"
                   :title="modal_titulo"
                   :ok-title="modal_botao"
                   close-title="Fechar"
                   v-model="showModalXml"
                   >
                   <div class="col-md-12 col-sm-12">
                       <b-form-text>Importar XML de NFe </b-form-text>
                       <vue-dropzone ref="myVueDropzone" id="dropzone"
                          :include-styling="true"
                           v-on:vdropzone-success="showSuccess"
                           v-on:vdropzone-error="showError"
                           v-on:vdropzone-sending="sendingEvent"
                           :options="dzOptions">
                       </vue-dropzone>
                   </div>
               <div slot="modal-footer" class="w-100">
                      <div class="float-right">
                          <b-btn @click="showModalXml=false" variant="secondary">
                            Fechar
                          </b-btn>
                      </div>
               </div>
          </b-modal>

          <!-- Modal Component -->
          <b-modal id="modal_upload_xml_cte"
                   ref="modal_upload_xml_cte"
                   :title="modal_titulo"
                   :ok-title="modal_botao"
                   close-title="Fechar"
                   v-model="showModalXmlCTe"
                   >
                   <div class="col-md-12 col-sm-12">
                       <b-form-text>Importar XML de CTe </b-form-text>
                       <vue-dropzone ref="myVueDropzoneCTe" id="dropzoneCTe"
                          :include-styling="true"
                           v-on:vdropzone-success="showSuccess"
                           v-on:vdropzone-error="showErrorCTe"
                           v-on:vdropzone-sending="sendingEvent"
                           :options="dzOptionsCTe">
                       </vue-dropzone>
                   </div>
               <div slot="modal-footer" class="w-100">
                      <div class="float-right">
                          <b-btn @click="showModalXmlCTe=false" variant="secondary">
                            Fechar
                          </b-btn>
                      </div>
               </div>
          </b-modal>

          <!-- Modal Component -->
          <b-modal id="modal_associar"
                   ref="modal_associar"
                   :title="modal_titulo"
                   :ok-title="modal_botao"
                   close-title="Fechar"
                   v-model="showModalAssociar"
                   size="lg"
                   :ok-disabled=form.errors.any()
                   @ok="onStoreAssociarDoc">
                   <b-container fluid class="p-a-0">
                       <b-row>
                           <b-col>
                               <b-form-text>Container</b-form-text>
                               <b-form-input type="text"
                                       placeholder="Container"
                                       v-model="form.num_container"
                                       >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('num_container')" v-if="form.errors.has('num_container')"></b-form-feedback>
                           </b-col>
                           <b-col>
                               <b-form-text>Lacre</b-form-text>
                               <b-form-input type="text"
                                       placeholder="Lacre"
                                       v-model="form.num_lacre"
                                       >
                               </b-form-input>
                               <b-form-feedback class="text-danger" v-text="form.errors.get('num_lacre')" v-if="form.errors.has('num_lacre')"></b-form-feedback>
                           </b-col>
                           <b-col>
                               <b-form-text>Observação</b-form-text>
                              <b-form-input type="text"
                                       placeholder="Observação"
                                       v-model="form.obs"
                                       >
                              </b-form-input>
                          </b-col>
                       </b-row>
                       <b-row class="m-t-5px p-a-0">
                       <table class="table-striped">
                           <thead>
                               <tr>
                                   <th style="width: 20%">Emitente</th>
                                   <th style="width: 25%">Chave</th>
                                   <th style="width: 10%">Número Fiscal</th>
                                   <th style="width: 10%">Série</th>
                                   <th style="width: 15%">Data</th>
                                   <th style="width: 5%">Ação</th>
                               </tr>
                            </thead>
                            <tbody>
                                <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfis">
                                   <td>
                                       {{ row.emi_nome }}
                                   </td>
                                   <td>
                                       {{ row.chave }}
                                   </td>
                                   <td>
                                       {{ row.num_fiscal }}
                                   </td>
                                   <td>
                                       {{ row.serie }}
                                   </td>
                                   <td>
                                       <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                   </td>
                                   <td>
                                       <i class="glyphicon glyphicon-remove" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDoc(index);"></i>
                                   </td>
                               </tr>
                           </tbody>
                       </table>
                       <br/>
                       <table class="table-striped">
                           <thead>
                               <tr>
                                   <th style="width: 100%">Adicionar NFe</th>
                               </tr>
                            </thead>
                            <tbody>
                                <tr class="bg-gray-light" style="display: table-row;">
                                   <td>
                                       <b-container fluid class="p-a-0">
                                          <b-row no-gutters>
                                             <b-col sm="10" md="10" class="m-t-5px p-a-0">
                                                 <b-form-input type="text"
                                                               placeholder=""
                                                               v-model="helpForm.chave"
                                                               >
                                                 </b-form-input>
                                                 <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                                             </b-col>
                                             <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                 <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDoc($event);" v-b-tooltip.hover.right="'Adicionar Documento'" style="cursor: pointer">
                                                 Adicionar
                                                 </b-btn>
                                             </b-col>
                                             <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                 <div class="float-left"><spinner v-if="loadingAddDoc" message="buscando..."></spinner></div>
                                             </b-col>
                                         </b-row>
                                      </b-container>
                                   </td>
                               </tr>
                           </tbody>
                       </table>
                  </b-row>
              </b-container>
              <div slot="modal-footer" class="w-100">
                     <div class="float-left"><spinner v-if="loading" message="Associando..."></spinner></div>
                     <div class="float-right">
                       <div class="float-left" v-if="this.errors_array.length>0">
                       <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                       <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                         <table class="table-striped" id="mais">
                              <tbody>
                                  <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                     <td>
                                       {{ item.erro }}
                                     </td>
                                 </tr>
                             </tbody>
                         </table>
                       </b-popover>
                     </div>
                     &nbsp;

                         <b-btn @click="showModalAssociar=false" variant="secondary">
                           Fechar
                         </b-btn>
                         <b-btn @click="onStoreAssociarDoc($event)" variant="secondary" :disabled="isDisabled">
                           Enviar
                         </b-btn>
                     </div>
              </div>
          </b-modal>

          <!-- Modal Component -->
          <b-modal id="modal_help"
                   ref="modal_help"
                   :title="modal_titulo"
                   close-title="Fechar"
                   v-model="showModalHelp"
                   size="lg">
              <b-container fluid class="p-a-0">
                  Tags disponíveis para campo observação: <br/>
                  #num_pedido = Número do pedido <br/>
                  #container = Número do container <br/>
                  #lacre = Número do lacre <br/>
                  #peso_bruto = Peso bruto das notas fiscais <br/>
                  #advalorem_percentual = Valor do percentual de Advalorem <br/><br/>
                  Atenção! O campo observação é formado pela Observação do CTE ( Pedido ) + Observação inserida no GRID ( Observação do GRID ).<br/><br/><br/>
                  Caso seja necessário filtrar a quantidade de UC de um pedido, digite o número do pedido,qtde, exemplo ( 12312-000001,10 ).
              </b-container>
          </b-modal>

          <GerarCteAjustado
          ref="gerarcteajustado">
          </GerarCteAjustado>

          <AssociarDocumentos
          v-on:reloadvue="onVuetableReload"
          ref="associardocumentos">
          </AssociarDocumentos>
        </div>
    </div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import GerarCteLoteFilterBar from './GerarCteLoteFilterBar'
import moment from 'moment'
import {VMoney} from 'v-money'
import accounting from 'accounting'
import GerarCteAjustado from '../components/GerarCteAjustado'
import GerarCTELoteDetalhes from './GerarCteLoteDetalhes'
import AssociarDocumentos from '../components/AssociarDocumentos'
import vueDropzone from 'vue2-dropzone'

Vue.component('gerarctelote-detalhes', GerarCTELoteDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': GerarCteLoteFilterBar,
        GerarCteAjustado,
        VMoney,
        vueDropzone,
        AssociarDocumentos
    },
    data () {
        return {
          dataExport: [],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          showPopover: false,
          loadingAddDoc: false,
          isDisabledAddDoc: false,
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          isFullscreen: false,
          showModalAssociar: false,
          showModalHelp: false,
          showModalXml: false,
          showModalXmlCTe: false,
          vn_total_lote: 0,
          datadoc: [],
          docfis: [],
          num_pedidos: [],
          num_ucs: [],
          tom_cnpjs: [],
          errors_array: [],
          Icms: { aliquota_contribuinte: 0
                , aliquota_nao_contribuinte: 0
                , uf_ini: ''
                , uf_fim: ''
            },
            dzOptions: {
                url: "/api/xmlnfe",
                maxFiles: 10,
                maxFilesize: 1,
                addRemoveLinks: false,
                thumbnailWidth: 140,
                thumbnailHeight: 10,
                uploadMultiple: false,
                acceptedFiles: ".xml",
                dictDefaultMessage: 'Arraste os arquivos aqui, ou clique aqui. Limite de 10 arquivos',
                dictFallbackMessage: 'O seu browser não suporta arrastar para cá. Clique aqui.',
                dictFallbackText: "Use o formulário alternativo abaixo para envio.",
                dictFileTooBig: "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo: {{maxFilesize}}MiB.",
                dictInvalidFileType: "Tipo do arquivo inválido para upload.",
                dictResponseError: "Server respondeu com código de erro {{statusCode}} code.",
                dictCancelUpload: "Cancelar envio",
                dictCancelUploadConfirmation: "Tem certeza que deseja cancelar o envio ?",
                dictRemoveFile: "Remover arquivo",
                dictMaxFilesExceeded: "Limite de envio excedido. Atualize a tela.",
                headers: { "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]').content }
            },
            dzOptionsCTe: {
                url: "/api/xmlcte",
                maxFiles: 10,
                maxFilesize: 1,
                addRemoveLinks: false,
                thumbnailWidth: 140,
                thumbnailHeight: 10,
                uploadMultiple: false,
                acceptedFiles: ".xml",
                dictDefaultMessage: 'Arraste os arquivos aqui, ou clique aqui. Limite de 10 arquivos',
                dictFallbackMessage: 'O seu browser não suporta arrastar para cá. Clique aqui.',
                dictFallbackText: "Use o formulário alternativo abaixo para envio.",
                dictFileTooBig: "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo: {{maxFilesize}}MiB.",
                dictInvalidFileType: "Tipo do arquivo inválido para upload.",
                dictResponseError: "Server respondeu com código de erro {{statusCode}} code.",
                dictCancelUpload: "Cancelar envio",
                dictCancelUploadConfirmation: "Tem certeza que deseja cancelar o envio ?",
                dictRemoveFile: "Remover arquivo",
                dictMaxFilesExceeded: "Limite de envio excedido. Atualize a tela.",
                headers: { "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]').content }
            },
          form: new Form({ pedunicar_id: '',
                           num_container: '',
                           num_lacre: '',
                           obs: '',
                           tp_orig_doc: 2,
                           docfis: [],
                       }),
          formCte: new Form({ pedunicar: [],
                        }),
         helpForm: new Form({chave:'', statusRecord: [], params: [],search:'', docs: []}),
        fields: [
            {
              name: '__slot:selecionado',
              title: '',
            },
            {
              name: '__slot:pessoa',
              title: 'Tomador'
            },
          {
            name: 'num_uc',
            title: 'N° UC',
            sortField: 'num_uc'
          },
          {
            name: '__slot:num_container',
            title: 'Container',
          },
          {
            name: '__slot:num_lacre',
            title: 'Lacre',
          },
          {
            name: '__slot:obs',
            title: 'Obs',
          },
          {
            name: 'vlr_total_receita',
            title: 'Valor Pedido',
            callback: 'formatNumber'
          },
          {
            name: 'vlr_total_advalorem',
            title: 'Valor Advalorem',
            callback: 'formatNumber'
          },
          {
            name: 'vlr_total',
            title: 'Valor Total',
            callback: 'formatNumber'
          },
          {
            name: '__slot:status_uc',
            title: 'Status',
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
      ],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        percentual_advalorem: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.pedunicar_id);
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.num_pedidos = null;
            this.num_pedidos = [];
            data_filter.num_pedidos.forEach((obj)=>{
                this.num_pedidos.push({
                    num_pedido: obj.text,
                });
            });

            this.num_ucs = null;
            this.num_ucs = [];
            data_filter.num_ucs.forEach((obj)=>{
                this.num_ucs.push({
                    num_uc: obj.text,
                });
            });

            this.tom_cnpjs = null;
            this.tom_cnpjs = [];
            data_filter.tom_cnpjs.forEach((obj)=>{
                this.tom_cnpjs.push({
                    tom_cnpj: obj.text,
                });
            });

            this.moreParams = {
                'num_pedidos': this.num_pedidos,
                'num_ucs': this.num_ucs,
                'for_cnpj': data_filter.for_cnpj,
                'tom_cnpjs': this.tom_cnpjs,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim,
                'status': data_filter.status.value
            }

            Vue.nextTick( () => {this.$refs.vuetable.reload(); })
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onVuetableReload() {
            this.moreParams = {};
            Vue.nextTick( () => this.$refs.vuetable.refresh());
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        showSuccess: function (file, message, xhr) {
            this.$snotify.success(message+' para arquivo '+file.name);
            Vue.nextTick( () => this.$refs.vuetable.refresh());
        },
        showError: function (file, message, xhr) {
            this.$snotify.error(message+' para arquivo '+file.name);
        },
        showErrorCTe: function (file, message, xhr) {
            this.$snotify.error(message.message+' para arquivo '+file.name);
        },
        sendingEvent (file, xhr, formData) {
            formData.append('paramName', 'some value or other');
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        addDoc() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.helpForm.docs = this.docfis;
            this.helpForm.post('/api/gerarctelote/adddoc').then(response =>
            {
                this.docfis.push({
                    id: response.docfis_id,
                    chave: response.chave,
                    num_fiscal: response.num_fiscal,
                    serie: response.serie,
                    dt_emissao: response.dt_emissao,
                    emi_nome: response.doc_fiscal_partes_env.emi_nome,
                    emi_cnpj: response.doc_fiscal_partes_env.emi_cnpj,
                    des_nome: response.doc_fiscal_partes_env.des_nome,
                    des_cnpj: response.doc_fiscal_partes_env.des_cnpj
                });
                new ReturnApi(response, this);
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this);
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
            });
        },
        onAssociarDoc (data) {

            this.$refs.associardocumentos.onAssociarDoc(data); // PedidoUnidadeCarga
            /*
            this.modal_titulo = "Associar Documentos";
            this.modal_botao = "Associar";
            this.modal_acao = "i";
            this.showModalAssociar = true;
            this.loadingAddDoc = false;
            this.isDisabledAddDoc = false;
            this.docfis = null;
            this.docfis = [];
            this.form.reset();
            this.form.pedunicar_id = data.rowData.pedunicar_id;
            if(data.rowData.carga_doc_unidade_carga.length==0)
            {
                this.form.num_container = data.rowData.num_container;
                this.form.num_lacre = data.rowData.num_lacre;
                this.form.obs = data.rowData.obs;
            }
            else
            {
                this.form.num_container = data.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.num_container;
                this.form.num_lacre = data.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.num_lacre;
                this.form.obs = data.rowData.carga_doc_unidade_carga[0].carga_doc[0].carga.obs;
            }

            if(data.rowData.carga_doc_unidade_carga.length>=1)
            {
                data.rowData.carga_doc_unidade_carga.forEach((obj)=>{
                    obj.carga_doc.forEach((obj2)=>{
                        this.docfis.push({
                            id : obj2.doc_fiscal.docfis_id,
                            chave : obj2.doc_fiscal.chave,
                            num_fiscal : obj2.doc_fiscal.num_fiscal,
                            serie : obj2.doc_fiscal.serie,
                            dt_emissao : obj2.doc_fiscal.dt_emissao,
                            emi_cnpj : obj2.doc_fiscal.doc_fiscal_partes_env.emi_cnpj,
                            emi_nome : obj2.doc_fiscal.doc_fiscal_partes_env.emi_nome,
                            des_cnpj : obj2.doc_fiscal.doc_fiscal_partes_env.des_cnpj,
                            des_nome : obj2.doc_fiscal.doc_fiscal_partes_env.des_nome
                        });
                    });
                });
            }
            else
            {
                this.form.docfis = null;
                this.form.docfis = [];
            }
            this.$refs.modal_associar.show();
            */
        },
        onStoreAssociarDoc()
        {
            this.form.docfis = this.docfis;
            this.loading = true;
            this.isDisabled = true;
            this.form.post('/api/gerarctelote/store/carga').then(response =>
            {
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this);
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
            });
        },
        onCreateCteLote()
        {
            this.vn_total_lote = 0;
            this.vlr_total = 0;
            this.$refs.vuetable.tableData.forEach((obj)=>{
                if(obj.selecionado==1)
                {
                    this.vn_total_lote = this.vn_total_lote+1;
                    this.vlr_total = this.vlr_total+obj.vlr_total;
                }
            });

            var vm = this;
            const onConfirmWrapper = () => {
                confirmLoteFn(vm);
            }

            let confirmLoteFn = function(vm) {
                vm.formCte.pedunicar = null;
                vm.formCte.pedunicar = [];

                vm.$refs.vuetable.tableData.forEach((obj)=>{
                    if(obj.selecionado==1)
                    {
                        vm.formCte.pedunicar.push({ pedunicar_id: obj.pedunicar_id });
                    }
                });

                if(vm.formCte.pedunicar.length>0)
                {
                    vm.formCte.post('/api/gerarctelote/store/ctelote').then(response =>
                    {
                        new ReturnApi(response, vm);
                    })
                    .catch(errors =>
                    {
                        new ReturnApi(errors, vm)
                    });
                }
            }

            let obj = {
              title: 'Gerar CTE em Lote',
              message: 'Deseja gerar um total de '+this.vn_total_lote+' CTE(s) com um valor total dos CTEs de R$ '+this.formatNumber(this.vlr_total),
              type: 'info',
              customCloseBtnText: 'Cancelar',
              customConfirmBtnText: 'Gerar',
              useConfirmBtn: true,
              onConfirm: onConfirmWrapper
            }
            this.$Simplert.open(obj);

        },
        onGerarCteAjustado(data)
        {
            this.$refs.gerarcteajustado.onCreate(data.rowData); // PedidoUnidadeCarga
        },
        onImportXml (data) {
            this.modal_titulo = "Importar XML de NFe";
            this.modal_botao = "Importar";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.$refs.modal_upload_xml.show();
        },
        onImportXmlCte (data) {
            this.modal_titulo = "Importar XML de CTe";
            this.modal_botao = "Importar";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.$refs.modal_upload_xml_cte.show();
        },
        onShowHelp() {
            this.modal_titulo = "Ajuda";
            this.modal_acao = "i";
            this.showModalHelp = true;
        },
        onGerarCteLote(pedunicar_id, data)
        {
            var vm = this;

            const onConfirmWrapper = () => {
                confirmFn(vm, pedunicar_id);
            }

            let confirmFn = function(vm, pedunicar_id) {
                vm.storeCteLote(pedunicar_id);
            }

            var vv_msg_cte = data.num_uc+' no valor total de R$ '+this.formatNumber(data.vlr_total)+' ?';

            let obj = {
              title: 'Gerar CTE',
              message: 'Deseja gerar o CTE da unidade de carga '+vv_msg_cte,
              type: 'info',
              customCloseBtnText: 'Cancelar',
              customConfirmBtnText: 'Gerar',
              useConfirmBtn: true,
              onConfirm: onConfirmWrapper
            }
            this.$Simplert.open(obj);
        },
        storeCteLote(pedunicar_id) {
            this.loadingAddDoc = true;
            this.isDisabled = true;
            this.formCte.pedunicar = null;
            this.formCte.pedunicar = [];
            // Loop com os marcados
            this.formCte.pedunicar.push({ pedunicar_id });
            this.formCte.post('/api/gerarctelote/store/ctelote').then(response =>
            {
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        listaClientesFornecedor(search) {
          if(search.length>=3)
          {
              this.isLoadingFor = true;
              this.helpForm.search = search;
              this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
              {
                  this.optionsFornecedor = [];
                  new ReturnApi(response, this, true, false, false);
                  response.items.forEach((obj)=>
                  {
                      this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                  });
                  this.isLoadingFor = false;
              })
              .catch(errors =>
              {
                  new ReturnApi(errors, this)
                });
            }
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        removeRowDoc: function(index) {
            this.docfis.splice(index, 1);
        },
        onDesassociar (data, status) {

            let form = this.form;

            var vm = this;
            var pedunicar_id = data.pedunicar_id;
            const onConfirmUnitWrapper = () => {
                confirmDesassociarFn(vm, pedunicar_id);
            }

            let confirmDesassociarFn = function(vm, pedunicar_id) {
                vm.form.pedunicar_id = pedunicar_id;
                vm.form.post('/api/associar/desassociar').then(response =>
                {
                    new ReturnApi(response, vm)
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, vm)
                });
            }

            let obj = {
                title: 'Você deseja Desassociar todas notas da UC '+data.num_uc+' ?',
                message: 'Esta ação é irreversível',
                customConfirmBtnText: 'Sim',
                customCloseBtnText: 'Não',
                type: 'info',
                useConfirmBtn: true,
                onConfirm: onConfirmUnitWrapper
            }

            this.$Simplert.open(obj);
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
          get () {
            return this.$store.state.vuetable.filterRow;
          },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
  }
  </script>
